var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"caption mb-1"},[_vm._v(" "+_vm._s(_vm.title)+" "),(typeof _vm.editable!=='undefined')?_c('v-icon',{staticClass:"mt-n1",attrs:{"small":""}},[_vm._v("mdi-pencil")]):_vm._e()],1),_c('div',{staticClass:"mb-2 position-relative body-2"},[_vm._t("default"),_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }